<template>
  <div>
    <v-form class="rating-form mb-2" @submit.prevent="createRating">
      <v-row :class="{ invalid: $v.rating.mark.$error }" ref="form">
        <v-col class="py-0">
          <v-rating
            v-model="rating.mark"
            background-color="orange lighten-3"
            color="orange"
            hover
            length="5"
            class="rating-form__stars mb-2"
          />
          <span v-show="$v.rating.mark.$error" class="error--text">{{ $t('Оцените сайт') }}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="6" class="py-0">
          <v-textarea
            v-model="rating.text"
            :label="$t('Оставьте отзыв или предложение по работе портала')"
            :height="100"
            outlined
            hide-details
            class="mb-3"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="py-0">
          <v-btn
            type="submit"
            color="primary"
            dark
            primary
          >
            {{ $t('Отправить') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import Rating from '@/model/rating'
import { minValue } from 'vuelidate/lib/validators'
import { mapMutations } from 'vuex'
import mixin from '@/plugins/mixin/mixin'

export default {
  mixins: [mixin],
  data: () => ({
    rating: {
      mark: 0,
      text: ''
    },
    rules: {
      rating: {
        mark: { minValue: minValue(1) }
      }
    },
  }),
  validations () {
    return this.rules
  },
  methods: {
    ...mapMutations(['setLoading']),
    // Валидация формы
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    createRating() {
      if (!this.validateForm()) {
        return
      }

      this.setLoading(true)

      Rating.createSiteRating(this.rating)
        .then((response) => {
          if (response.status === 201) {
            this.setLoading(false)
            this.$noty.success(this.$i18n.t('Спасибо за Вашу оценку!'), {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
            // очищаем форму
            this.rating = {
              text: ''
            }
          }
        })
        .catch((error) => {
          this.$noty.error(this.$i18n.t('Голосование на данный момент недоступно.'), {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
        })
      this.setLoading(false)
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError () {
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    },
  }
}
</script>
